<template>
  <div class="container mx-auto">
    <div class="text-center">
      <h1 class="font-bold text-2xl py-5">Ecco tutti gli enti straordinari che hanno aderito a questa iniziativa</h1>
    </div>
    <div>

      <div class="flex flex-wrap justify-center">
        <div v-if="loading" class="text-center">
          <span class="loading loading-bars loading-lg"></span>
          <div class="card bg-base-100 w-96 shadow-xl m-3" v-for="i in [1,2,3,4,5,6,7,8,9]">
            <div class="card-body p-3">
              <div class="flex justify-start gap-3 items-center">
                <div class="avatar">
                  <div class="skeleton h-16 w-16 rounded-full"></div>
                </div>
                <div class="card-title">
                  <div class="skeleton h-4 w-28"></div>
                </div>
                <div>
                  <div class="rounded-full">
                    <div class="skeleton h-4 w-4 rounded-full"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ui-onp-card v-if="results.length" :record="item" :tpl="'light'" v-for="item in results" @record:open="openRecord" />
      </div>
    </div>

    <template-disclaimer />
  </div>
</template>
<script setup lang="ts">
const showActions = inject('showActions')
// Cambia il valore per questa pagina
showActions.value = false

// Cambia style di navbar per questa pagina
const navbarType = inject('navbarType')
navbarType.value = 'light';

import type {ONPRecord} from "~/types/record";
const {getAllOnp} = useRecords();
const results: Ref<ONPRecord[]> = ref([]);
const loading = ref(true);
const loadData = async () => {
  results.value = await getAllOnp();
  loading.value = false;
}
results.value = loadData();


const openRecord = async (record: ONPRecord) => {
  await navigateTo({path: `/cerca/record-${record.id}`})
}

useSeoMeta({
  title: 'Partecipanti',
  description: 'Regali solidali, donazioni libere e campagne di raccolta fondi: consulta la lista di tutti gli enti che hanno aderito al Market Solidale di Natale',
  image: 'https://onp.app/seo/partecipanti.jpg'
})
</script>